// Clinical findings dropdown options with Custom option for manual entry
const clinicalFindingsOptions = ['', 'Custom', 'No Findings', 'Deformities', 'Contusions', 'Abrasions', 'Penetrations', 'Burns', 'Tenderness', 'Lacerations', 'Swelling'];

const nremtManualAssessmentLayout = {
  header: [
    { key: 'lead', label: '', colSpan: 1 },
    { key: 'objectives', label: 'STUDENT OBJECTIVES', colSpan: 1 },
    { key: 'prompt', label: 'INSTRUCTOR PROMPT', colSpan: 1 },
    { key: 'score', label: 'SCORE', colSpan: 1 }
  ],
  rows: [
    { type: 'section', id: 'scene-size-up', title: 'SCENE SIZE-UP' },
    { type: 'objective', id: 'scene-safety', text: 'Scene Safety', promptId: 'scene-safety', scoreId: 'scene-safety-score', mergeLeadIntoObjective: true },
    { type: 'objective', id: 'bsi-ppe', text: 'BSI/PPE', promptId: 'bsi-ppe', scoreId: 'bsi-ppe-score', mergeLeadIntoObjective: true },
    { type: 'objective', id: 'noi-moi', text: 'Nature of Illness/Mechanism of Injury', promptId: 'noi-moi', scoreId: 'noi-moi-score', mergeLeadIntoObjective: true },
    { type: 'objective', id: 'number-of-patients', text: 'Number of Patients', promptId: 'number-of-patients', scoreId: 'number-of-patients-score', mergeLeadIntoObjective: true },
    { type: 'objective', id: 'additional-resources', text: 'Need for Additional Resources', promptId: 'additional-resources', scoreId: 'additional-resources-score', mergeLeadIntoObjective: true },
    { type: 'objective', id: 'spinal-precautions', text: 'Need for Spinal Precautions', promptId: 'spinal-precautions', scoreId: 'spinal-precautions-score', mergeLeadIntoObjective: true },

    { type: 'section', id: 'primary-assessment', title: 'PRIMARY ASSESSMENT' },
    { type: 'subsection', id: 'loc-heading', title: 'LOC' },
    {
      type: 'objective',
      id: 'general-impression',
      text: 'General Impression',
      promptId: 'general-impression',
      scoreId: 'general-impression-score'
    },
    {
      type: 'objectiveWithNote',
      id: 'loc-avpu',
      text: 'Alert - Verbal - Pain - Unresponsive',
      textStyle: 'italic',
      objectiveAlign: 'center',
      exclusiveOptions: [
        { id: 'loc-avpu-a', label: 'A' },
        { id: 'loc-avpu-v', label: 'V' },
        { id: 'loc-avpu-p', label: 'P' },
        { id: 'loc-avpu-u', label: 'U' }
      ],
      note: 'Ø  If the patient is alert, proceed to mental status',
      noteMergeLead: true,
      noteColSpan: 3,
      noteBreaksSubsection: true,
      promptId: 'loc-avpu',
      scoreId: 'loc-avpu-score'
    },
    { type: 'subsection', id: 'mental-status-heading', title: 'Mental status' },
    {
      type: 'checkboxRow',
      id: 'mental-status',
      items: [
        { id: 'mental-person', text: 'Person', inputId: 'mental-person-input' },
        { id: 'mental-place', text: 'Place', inputId: 'mental-place-input' },
        { id: 'mental-time', text: 'Time', inputId: 'mental-time-input' }
      ],
      mergeObjectiveWithPrompt: true,
      objectiveAlign: 'center',
      scoreId: 'mental-status-score'
    },
    {
      type: 'checkboxRow',
      id: 'mental-status-cc',
      items: [
        { id: 'mental-cc', text: 'C/C', inputId: 'mental-cc-input' }
      ],
      promptId: 'mental-status-cc-prompt',
      scoreId: 'mental-status-cc-score'
    },
    { type: 'subsection', id: 'circulation-heading', title: 'Circulation' },
    { type: 'objective', id: 'major-bleeding', text: 'Check for Major Bleeding', promptId: 'major-bleeding', scoreId: 'major-bleeding-score' },
    {
      type: 'checkboxRow',
      id: 'pulse-check',
      items: [
        { id: 'pulse-rate', text: 'Rate', selectId: 'pulse-rate-select', options: ['', 'Normal', 'Fast', 'Slow', 'Absent'] },
        { id: 'pulse-rhythm', text: 'Rhythm', selectId: 'pulse-rhythm-select', options: ['', 'Regular', 'Irregular'] },
        { id: 'pulse-quality', text: 'Quality', selectId: 'pulse-quality-select', options: ['', 'Normal', 'Weak', 'Bounding', 'Absent'] }
      ],
      mergeObjectiveWithPrompt: true,
      objectiveAlign: 'center',
      scoreId: 'pulse-check-score'
    },
    {
      type: 'checkboxRow',
      id: 'skin-check',
      items: [
        { id: 'skin-color', text: 'Color', selectId: 'skin-color-select', options: ['', 'Normal', 'Pale', 'Cyanotic', 'Flushed', 'Jaundice'] },
        { id: 'skin-temperature', text: 'Temperature', selectId: 'skin-temp-select', options: ['', 'Normal', 'Hot', 'Cool', 'Cold'] },
        { id: 'skin-moisture', text: 'Moisture', selectId: 'skin-moisture-select', options: ['', 'Normal', 'Dry', 'Moist', 'Diaphoretic'] }
      ],
      mergeObjectiveWithPrompt: true,
      objectiveAlign: 'center',
      scoreId: 'skin-check-score'
    },
    { type: 'subsection', id: 'airway-heading', title: 'Airway' },
    { type: 'objective', id: 'airway-sounds', text: 'Listen for Abnormal Sounds', promptId: 'airway-sounds', scoreId: 'airway-sounds-score' },
    { type: 'objective', id: 'airway-patent', text: 'Determine if the Airway is Patent', promptId: 'airway-patent', scoreId: 'airway-patent-score' },
    { type: 'objective', id: 'airway-maneuver', text: 'Determine need for Airway Maneuver or Adjunct', promptId: 'airway-maneuver', scoreId: 'airway-maneuver-score' },
    { type: 'subsection', id: 'breathing-heading', title: 'Breathing' },
    { type: 'objective', id: 'breathing-rate', text: 'Determine Breathing Rate (Quick Rate)', promptId: 'breathing-rate', scoreId: 'breathing-rate-score' },
    { type: 'objective', id: 'breathing-adequate', text: 'Determine if Breathing Adequate', promptId: 'breathing-adequate', scoreId: 'breathing-adequate-score' },
    { type: 'objective', id: 'oxygen-decision', text: 'Determine the Need to Administer or Withhold Oxygen', promptId: 'oxygen-decision', scoreId: 'oxygen-decision-score' },
    { type: 'subsection', id: 'decision-heading', title: 'Decision' },
    { type: 'objective', id: 'patient-priority', text: 'Determines Patient Priority (High or Low)', promptId: 'patient-priority', scoreId: 'patient-priority-score' },

    { type: 'section', id: 'secondary-assessment', title: 'SECONDARY ASSESSMENT' },
    {
      type: 'noteCheckboxRow',
      id: 'dcap-btls',
      items: [
        { id: 'dcap-deformities', text: 'Deformities' },
        { id: 'dcap-contusions', text: 'Contusions' },
        { id: 'dcap-abrasions', text: 'Abrasions' },
        { id: 'dcap-penetrations', text: 'Penetrations' },
        { id: 'dcap-burns', text: 'Burns' },
        { id: 'dcap-tenderness', text: 'Tenderness' },
        { id: 'dcap-lacerations', text: 'Lacerations' },
        { id: 'dcap-swelling', text: 'Swelling' }
      ],
      scoreId: 'dcap-btls-score',
      align: 'center'
    },
    { type: 'subsection', id: 'head-subsection', title: 'Head' },
    {
      type: 'threeColumnCheckboxRow',
      id: 'head',
      items: [
        { id: 'head-skull-ears', text: 'Skull + Ears', selectId: 'head-skull-ears-select', customInputId: 'head-skull-ears-custom', options: clinicalFindingsOptions },
        { id: 'head-eyes', text: 'Eyes', selectId: 'head-eyes-select', options: ['', 'PERRL', 'Unequal', 'Dilated', 'Constricted', 'Non-reactive'] },
        { id: 'head-mouth-face', text: 'Mouth + Face', selectId: 'head-mouth-face-select', customInputId: 'head-mouth-face-custom', options: clinicalFindingsOptions }
      ],
      scoreId: 'head-score'
    },
    { type: 'subsection', id: 'neck-subsection', title: 'Neck' },
    {
      type: 'threeColumnCheckboxRow',
      id: 'neck',
      items: [
        { id: 'neck-trachea', text: 'Trachea', selectId: 'neck-trachea-select', options: ['', 'Midline', 'Deviated'] },
        { id: 'neck-jvd', text: 'JVD', selectId: 'neck-jvd-select', options: ['', 'Absent', 'Present'] },
        { id: 'neck-spine', text: 'Spine', inputId: 'neck-spine-input' }
      ],
      scoreId: 'neck-score'
    },
    {
      type: 'objective',
      id: 'cervical-collar',
      text: 'APPLIES CERVICAL COLLAR',
      checkboxId: 'cervical-collar-checkbox',
      mergeObjectiveWithPrompt: true,
      objectiveAlign: 'center',
      scoreId: 'cervical-collar-score'
    },
    { type: 'subsection', id: 'chest-subsection', title: 'Chest' },
    {
      type: 'checkboxRow',
      id: 'chest',
      items: [
        { id: 'chest-inspects', text: 'Inspects', selectId: 'chest-inspects-select', customInputId: 'chest-inspects-custom', options: clinicalFindingsOptions },
        { id: 'chest-palpates', text: 'Palpates', selectId: 'chest-palpates-select', customInputId: 'chest-palpates-custom', options: clinicalFindingsOptions },
        { id: 'chest-auscultates', text: 'Auscultates', selectId: 'chest-auscultates-select', options: ['', 'Clear', 'Diminished', 'Absent', 'Wheezes', 'Crackles', 'Rhonchi'] }
      ],
      mergeObjectiveWithPrompt: true,
      objectiveAlign: 'center',
      scoreId: 'chest-score'
    },
    { type: 'subsection', id: 'abdomen-pelvis-subsection', title: 'Abd + pelvis' },
    {
      type: 'checkboxRow',
      id: 'abdomen-pelvis',
      items: [
        { id: 'abdomen-quadrants', text: '4 Quadrants', selectId: 'abdomen-quadrants-select', options: ['', 'Soft', 'Rigid', 'Distended', 'Tender'] },
        { id: 'abdomen-pelvis-area', text: 'Pelvis', selectId: 'abdomen-pelvis-select', options: ['', 'Stable', 'Unstable', 'Tender'] },
        { id: 'abdomen-genitalia', text: 'Genitalia', selectId: 'abdomen-genitalia-select', customInputId: 'abdomen-genitalia-custom', options: clinicalFindingsOptions }
      ],
      mergeObjectiveWithPrompt: true,
      objectiveAlign: 'center',
      scoreId: 'abdomen-pelvis-score'
    },
    { type: 'subsection', id: 'legs-subsection', title: 'Legs (bilateral)' },
    {
      type: 'checkboxRow',
      id: 'legs',
      items: [
        { id: 'legs-inspects', text: 'Inspects', selectId: 'legs-inspects-select', customInputId: 'legs-inspects-custom', options: clinicalFindingsOptions },
        { id: 'legs-palpates', text: 'Palpates', selectId: 'legs-palpates-select', customInputId: 'legs-palpates-custom', options: clinicalFindingsOptions },
        { id: 'legs-csm', text: 'CSM', selectId: 'legs-csm-select', options: ['', 'Intact', 'Absent', 'Diminished'] }
      ],
      mergeObjectiveWithPrompt: true,
      objectiveAlign: 'center',
      scoreId: 'legs-score'
    },
    { type: 'subsection', id: 'arms-subsection', title: 'Arms (bilateral)' },
    {
      type: 'checkboxRow',
      id: 'arms',
      items: [
        { id: 'arms-inspects', text: 'Inspects', selectId: 'arms-inspects-select', customInputId: 'arms-inspects-custom', options: clinicalFindingsOptions },
        { id: 'arms-palpates', text: 'Palpates', selectId: 'arms-palpates-select', customInputId: 'arms-palpates-custom', options: clinicalFindingsOptions },
        { id: 'arms-csm', text: 'CSM', selectId: 'arms-csm-select', options: ['', 'Intact', 'Absent', 'Diminished'] }
      ],
      mergeObjectiveWithPrompt: true,
      objectiveAlign: 'center',
      scoreId: 'arms-score'
    },
    { type: 'subsection', id: 'posterior-subsection', title: 'Posterior' },
    {
      type: 'checkboxRow',
      id: 'posterior',
      items: [
        { id: 'posterior-thoracic', text: 'Thoracic', selectId: 'posterior-thoracic-select', customInputId: 'posterior-thoracic-custom', options: clinicalFindingsOptions },
        { id: 'posterior-lumbar', text: 'Lumbar', selectId: 'posterior-lumbar-select', customInputId: 'posterior-lumbar-custom', options: clinicalFindingsOptions },
        { id: 'posterior-sacral', text: 'Sacral + Coccyx', selectId: 'posterior-sacral-select', customInputId: 'posterior-sacral-custom', options: clinicalFindingsOptions }
      ],
      mergeObjectiveWithPrompt: true,
      objectiveAlign: 'center',
      scoreId: 'posterior-score'
    },
    {
      type: 'objective',
      id: 'secondary-injuries',
      text: 'Manages Secondary Injuries',
      checkboxId: 'secondary-injuries-checkbox',
      mergeLeadIntoObjective: true,
      mergeObjectiveWithPrompt: true,
      objectiveAlign: 'center',
      scoreId: 'secondary-injuries-score',
      breaksSubsection: true
    },

    {
      type: 'subsection',
      id: 'pmh-heading',
      title: 'Past medical history',
      leadClassName: 'nremt-lead-subheading nremt-lead-subheading--ample'
    },
    {
      type: 'objective',
      id: 'sample-history-label',
      text: 'Allergies – Medications – Past History – Last Oral Intake – Events Leading',
      textStyle: ['italic', 'tiny'],
      className: 'nremt-letter-subheading nremt-objective-borderless',
      promptText: 'Onset – Provoke – Quality – Radiate – Severity – Time',
      promptTextStyle: ['italic', 'tiny']
    },
    {
      type: 'letterInputRow',
      id: 'sample-history',
      text: 'A',
      studentInputId: 'sample-history-a-input',
      checkboxId: 'sample-history-a-checkbox',
      promptId: 'sample-history-a-note',
      scoreId: 'sample-history-score',
      className: 'nremt-objective-borderless',
      promptCheckboxes: [
        { id: 'sample-history-opqrst-o', letter: 'O', text: 'Onset' }
      ]
    },
    {
      type: 'letterInputRow',
      id: 'sample-history-m',
      text: 'M',
      studentInputId: 'sample-history-m-input',
      checkboxId: 'sample-history-m-checkbox',
      promptId: 'sample-history-m-note',
      className: 'nremt-objective-borderless',
      promptCheckboxes: [
        { id: 'sample-history-opqrst-p', letter: 'P', text: 'Provoke' }
      ]
    },
    {
      type: 'letterInputRow',
      id: 'sample-history-p',
      text: 'P',
      studentInputId: 'sample-history-p-input',
      checkboxId: 'sample-history-p-checkbox',
      promptId: 'sample-history-p-note',
      className: 'nremt-objective-borderless',
      promptCheckboxes: [
        { id: 'sample-history-opqrst-q', letter: 'Q', text: 'Quality' }
      ]
    },
    {
      type: 'letterInputRow',
      id: 'sample-history-l',
      text: 'L',
      studentInputId: 'sample-history-l-input',
      checkboxId: 'sample-history-l-checkbox',
      promptId: 'sample-history-l-note',
      className: 'nremt-objective-borderless',
      promptCheckboxes: [
        { id: 'sample-history-opqrst-r', letter: 'R', text: 'Radiate' }
      ]
    },
    {
      type: 'letterInputRow',
      id: 'sample-history-e',
      text: 'E',
      studentInputId: 'sample-history-e-input',
      checkboxId: 'sample-history-e-checkbox',
      promptId: 'sample-history-e-note',
      className: 'nremt-objective-borderless',
      objectiveRowSpan: 3,
      promptCheckboxes: [
        { id: 'sample-history-opqrst-s', letter: 'S', text: 'Severity' }
      ]
    },
    {
      type: 'opqrstOnlyRow',
      id: 'sample-history-t-row',
      skipObjectiveCell: true,
      promptId: 'sample-history-t-note',
      promptCheckboxes: [
        { id: 'sample-history-opqrst-t', letter: 'T', text: 'Time' }
      ]
    },
    {
      type: 'opqrstOnlyRow',
      id: 'sample-history-other-row',
      skipObjectiveCell: true,
      promptId: 'sample-history-other-note',
      promptCheckboxes: [
        { id: 'sample-history-opqrst-other', letter: 'Other', text: 'Other' }
      ]
    },
    { type: 'subsection', id: 'vitals-heading', title: 'Vital signs' },
    {
      type: 'checkboxRow',
      id: 'vitals-row-1',
      items: [
        { id: 'vitals-bp', text: 'BP', inputId: 'vitals-bp-input' },
        { id: 'vitals-respiratory-rate', text: 'RR', inputId: 'vitals-rr-input' },
        { id: 'vitals-spo2', text: 'SPO2', inputId: 'vitals-spo2-input' },
        { id: 'vitals-gcs', text: 'GCS', inputId: 'vitals-gcs-input' }
      ],
      mergeObjectiveWithPrompt: true,
      objectiveAlign: 'center',
      scoreId: 'vitals-row-1-score'
    },
    {
      type: 'checkboxRow',
      id: 'vitals-row-2',
      items: [
        { id: 'vitals-heart-rate', text: 'HR', inputId: 'vitals-hr-input' },
        { id: 'vitals-lung-sounds', text: 'LS', inputId: 'vitals-ls-input' },
        { id: 'vitals-pupils', text: 'Pupils', inputId: 'vitals-pupils-input' },
        { id: 'vitals-bgl', text: 'BGL', inputId: 'vitals-bgl-input' }
      ],
      mergeObjectiveWithPrompt: true,
      objectiveAlign: 'center',
      scoreId: 'vitals-row-2-score'
    },
    {
      type: 'objective',
      id: 'field-impression',
      text: 'Field Impression and Treatment Plan',
      checkboxId: 'field-impression-checkbox',
      promptId: 'field-impression',
      scoreId: 'field-impression-score'
    },

    { type: 'section', id: 'reassessment', title: 'REASSESSMENT' },
    {
      type: 'objective',
      id: 'repeat-primary',
      text: 'Repeat Primary Assessment + Perform Detailed Physical Exam',
      promptId: 'repeat-primary',
      scoreId: 'repeat-primary-score',
      mergeLeadIntoObjective: true
    },
    {
      type: 'objective',
      id: 'evaluate-response',
      text: 'Evaluate Response to Treatment',
      promptId: 'evaluate-response',
      scoreId: 'evaluate-response-score',
      mergeLeadIntoObjective: true
    },
    {
      type: 'objective',
      id: 'repeat-vitals',
      text: 'Repeat Vital Signs and Look for Trends',
      promptId: 'repeat-vitals',
      scoreId: 'repeat-vitals-score',
      mergeLeadIntoObjective: true
    },
    {
      type: 'objective',
      id: 'reassess-frequency',
      text: 'Explain How Often to Reassess',
      promptId: 'reassess-frequency',
      scoreId: 'reassess-frequency-score',
      mergeLeadIntoObjective: true
    },
    {
      type: 'objective',
      id: 'radio-report',
      text: 'Provide Radio or Verbal Report',
      promptId: 'radio-report',
      scoreId: 'radio-report-score',
      mergeLeadIntoObjective: true
    }
  ]
};

export default nremtManualAssessmentLayout;
